export default {"src":"/_next/static/media/slider_64.73aa9418.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};